module.exports = "bundles/3b6b40ae824792a526220ce9a82fa074.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/pie-charts/pie-chart-70.png
// module id = 134
// module chunks = 0